// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IExpressSetupPlanYearDto
 */
export interface IExpressSetupPlanYearDto {
    /**
     * 
     * @type {string}
     * @memberof IExpressSetupPlanYearDto
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof IExpressSetupPlanYearDto
     */
    valid_from?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IExpressSetupPlanYearDto
     */
    valid_to?: Date;
}

/**
 * Check if a given object implements the IExpressSetupPlanYearDto interface.
 */
export function instanceOfIExpressSetupPlanYearDto(value: object): value is IExpressSetupPlanYearDto {
    return true;
}

export function IExpressSetupPlanYearDtoFromJSON(json: any): IExpressSetupPlanYearDto {
    return IExpressSetupPlanYearDtoFromJSONTyped(json, false);
}

export function IExpressSetupPlanYearDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IExpressSetupPlanYearDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'valid_from': json['valid_from'] == null ? undefined : (new Date(json['valid_from'])),
        'valid_to': json['valid_to'] == null ? undefined : (new Date(json['valid_to'])),
    };
}

export function IExpressSetupPlanYearDtoToJSON(json: any): IExpressSetupPlanYearDto {
    return IExpressSetupPlanYearDtoToJSONTyped(json, false);
}

export function IExpressSetupPlanYearDtoToJSONTyped(value?: IExpressSetupPlanYearDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'valid_from': value['valid_from'] == null ? undefined : ((value['valid_from']).toISOString().substring(0,10)),
        'valid_to': value['valid_to'] == null ? undefined : ((value['valid_to']).toISOString().substring(0,10)),
    };
}

